<template>
  <div class="container-fluid">
    <ErrorView v-if="errorStatus" />
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { useErrorStore } from "@/store/error/error";
import ErrorView from "@/views/Error/ErrorView.vue";
import { colorManager } from "@/services/platform/color-manager";
import { usePlatformStore } from "@/store/platform/platform";
import { useTrainingCourseStore } from "@/store/training-course/training-course";

export default {
  name: "LayoutView",
  components: { ErrorView },
  computed: {
    ...mapState(useErrorStore, {
      errorStatus: (store) => store.status,
    }),
    ...mapState(usePlatformStore, {
      design: (store) => store.design,
    }),
    ...mapState(useTrainingCourseStore, {
      trainingCourse: (store) => store.trainingCourse,
    }),
  },
  mounted() {
    colorManager.setPlatformStyle(null, this.design);
  },
};
</script>

<style lang="scss" scoped></style>
